import { OmixAtlasTableColumns } from '../../../@core/interfaces';

export const PUBMED_ID_DETAILS_LINK: string = 'https://pubmed.ncbi.nlm.nih.gov';

export const DATASET_TAGS_ORDER: string[] = [
  'experimentalFactors', 'organism', 'strain', 'disease', 'tissue', 'drug', 'cellType', 'cellLine',
];

export const MAX_TAGS: number = 4;
export const MAX_TAGS_CHARTS: number = 5;
export const MAX_TAG_VALUE_LENGTH: number = 30;
export const MAX_TAG_VALUE_LENGTH_CHARTS: number = 25;
export const MAX_PUBLICATION_LINK_LENGTH: number = 20;

export const pathwayTableColumns: OmixAtlasTableColumns[] = [
  {
    field: 'pathway',
    label: 'Pathway Name',
    type: 'text',
    width: 18
  }, {
    field: 'padj',
    label: 'Adj. P Value',
    type: 'text',
    width: 10
  }, {
    field: 'enrichment_score',
    label: 'Enrichment Score',
    type: 'text',
    width: 10
  }
];
